import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService, RechargeService } from '@app/core/services';
import { Mask, User } from '@app/models/backend';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-mask-modal',
  templateUrl: './mask-modal.component.html',
  styleUrls: ['./mask-modal.component.scss']
})
export class MaskModalComponent implements OnInit {

  partyMasks: Mask[] = <Mask[]>[];
  mask!: Mask;

  user!: User;
  form!: FormGroup;

  isEditMode: boolean = false;
  submitted: boolean = false;
  success: boolean = false;

  constructor(private fb: FormBuilder,
              private rechargeService: RechargeService,
              private notification: NotificationService,
              private modalRef: BsModalRef,
              private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.initForm();
  }

  // -- On Submit -- //
  submit() {
    this.spinner.show();
    const tempMask: Mask =
    {
      partyMaskId: 0,
      businessId:  this.user.businessId,
      maskName:    this.form.value.maskName,
      maskNumber:  this.form.value.maskNumber,
      description: this.form.value.description
    }
    if (!this.isEditMode) {
      this.rechargeService.addMask(tempMask).subscribe((res: any) => {
        this.spinner.hide();
        this.submitted = true;
        this.success = true;
        this.partyMasks.push(tempMask);
        this.notification.success(res['message']);
      }, error => {
        this.spinner.hide();
        this.modalRef.hide();
        this.notification.error(error['message']);
      });
    } else {
      tempMask.partyMaskId = this.mask.partyMaskId;
      tempMask.businessId = this.mask.businessId;
      this.rechargeService.updateMask(tempMask).subscribe((res: any) => {
        this.spinner.hide();
        this.submitted = true;
        this.success = true;
        this.mask.maskName = tempMask.maskName;
        this.mask.maskNumber = tempMask.maskNumber;
        this.mask.description = tempMask.description;
        this.notification.success(res['message']);
      }, error => {
        this.spinner.hide();
        this.modalRef.hide();
        this.notification.error(error['message']);
      });
    }
  }

  // -- Close Modal -- //
  close(): void {
    this.modalRef.hide();
  }

  // -- Init Form -- //
  initForm(): void {
    this.form = this.fb.group({
      maskName:     ['', Validators.required],
      maskNumber:   ['', Validators.required],
      description:  ['']
    });
  }

  public get maskName() {
    return this.form.controls['maskName'].hasError('required');
  }

  public get maskNumber() {
    return this.form.controls['maskNumber'].hasError('required');
  }

}
